import { documentAvailable } from '~/utils/client-detection';

const fontCss = `
@font-face {
	font-family: 'audi-iconfont';
	src: url('https://d1p8elq7q5x0x6.cloudfront.net/ngc/ngc-fonts/audi-iconfont.eot');
	src: url('https://d1p8elq7q5x0x6.cloudfront.net/ngc/ngc-fonts/audi-iconfont.eot?#iefix') format('eot'),
		url('https://d1p8elq7q5x0x6.cloudfront.net/ngc/ngc-fonts/audi-iconfont.woff2') format('woff2'),
		url('https://d1p8elq7q5x0x6.cloudfront.net/ngc/ngc-fonts/audi-iconfont.woff') format('woff'),
		url('https://d1p8elq7q5x0x6.cloudfront.net/ngc/ngc-fonts/audi-iconfont.ttf') format('truetype'),
		url('https://d1p8elq7q5x0x6.cloudfront.net/ngc/ngc-fonts/audi-iconfont.svg#audi-iconfont') format('svg');
	font-weight: normal;
	font-style: normal;
}
`;

const font = documentAvailable() ? document?.createElement('style') : undefined;
font?.appendChild(document?.createTextNode(fontCss));

export { font };
